import { structure } from './state'
import $ from 'jquery'

export const legal = s => (id) => {
    return s.legal['I'+id] || $.extend(true, {}, structure)
}

export const credit = s => (id, creditId) => {
    return s.credit['I'+id+'L'+creditId] || $.extend(true, {}, structure)
}

export const project = s => (id) => {
    return s.project['I'+id] || $.extend(true, {}, structure)
}

export const review = s => (id, reviewId) => {
    return s.review['I'+id+'L'+reviewId] || $.extend(true, {}, structure)
}

export const order = s => (id) => {
    return s.order['I'+id] || $.extend(true, {}, structure)
}

export default {
    legal,
    credit,
    project,
    review,
    order
}
